// Google H5 Games Ads (Ad Placement API) rewarded-ad helper.
//
// Shows a `type: 'reward'` adBreak. Coins are granted ONLY after the full ad
// is watched (adViewed). If the ad is skipped/dismissed early, no reward.
// If no ad is available (or the ad library isn't loaded, e.g. local dev), the
// reward is granted anyway so the flow stays usable.

import { addCoins, AD_REWARD } from "./coins";

export function showRewardedAd({ onSuccess, onDismissed } = {}) {
  const adBreak =
    typeof window !== "undefined" && (window.adBreak || window.adConfig);

  // Ad library not available (local dev / blocked) → grant reward directly
  if (typeof adBreak !== "function") {
    const balance = addCoins(AD_REWARD);
    if (onSuccess) onSuccess(balance);
    return;
  }

  let adShown = false;
  let callbackFired = false;

  adBreak({
    type: "reward",
    name: "earn-coins-reward",
    beforeReward: (showAdFn) => {
      // Ad is preloaded and ready — show it immediately
      adShown = true;
      showAdFn();
    },
    adViewed: () => {
      // Full ad watched → award coins
      callbackFired = true;
      const balance = addCoins(AD_REWARD);
      if (onSuccess) onSuccess(balance);
    },
    adDismissed: () => {
      // Ad skipped/dismissed early → no reward
      callbackFired = true;
      if (onDismissed) onDismissed();
    },
    adBreakDone: (placementInfo) => {
      // No ad was available to show → grant coins anyway for better UX
      if (!adShown && !callbackFired) {
        const balance = addCoins(AD_REWARD);
        if (onSuccess) onSuccess(balance);
      }
    },
  });
}
